import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, Redirect } from 'react-router-dom';
import { createBDROLoginRoute } from '@hip/helpers';
import { getAuthError, getAuthIsLoading, getIsLoggedIn, } from '../../core/auth/selectors';
import { actions } from '../../core/auth/actions';
import styles from './bdroLogin.module.css';
import { BdroLoginForm } from './bdroLoginForm/bdroLoginForm';
import { BdroLoginError } from './bdroLoginError/bdroLoginError';
var DEFAULT_REDIRECT_PATH = '/';
export var BdroLogin = function () {
    var dispatch = useDispatch();
    var isLoggedIn = useSelector(getIsLoggedIn);
    var isLoading = useSelector(getAuthIsLoading);
    var error = useSelector(getAuthError);
    var errorNode = React.useMemo(function () { return (error ? React.createElement(BdroLoginError, { text: error }) : null); }, [error]);
    // Reset login error on first load
    React.useEffect(function () {
        dispatch(actions.resetLoginError());
    }, []);
    var handleSubmit = React.useCallback(function (data) {
        dispatch(actions.makeLogin(data));
    }, []);
    var location = useLocation();
    if (isLoggedIn) {
        var params = new URLSearchParams(location.search);
        var bdroLoginPath = createBDROLoginRoute();
        var redirectUrl = params.get('redirect_url');
        if (redirectUrl === bdroLoginPath || !redirectUrl) {
            redirectUrl = DEFAULT_REDIRECT_PATH;
        }
        return (React.createElement("div", null,
            React.createElement("h1", null,
                "Redirect: ",
                redirectUrl),
            React.createElement(Redirect, { to: redirectUrl })));
    }
    return (React.createElement("div", { className: styles.BdroLoginRoot },
        React.createElement(BdroLoginForm, { isPending: isLoading, onSubmit: handleSubmit, errorNode: errorNode })));
};
